import {FC, useEffect} from "react";
import {Grid, TextField, Tooltip} from "@material-ui/core";
import * as React from "react";
import {AkamaiTokenData} from "./types/akamaiTokenData";


interface Props {
    akamai_token: AkamaiTokenData;
    akamai_key : string ;
    window : string;
}

const AkamaiToken : FC<Props> = ({akamai_token , akamai_key , window}) => {

    const [key , setKey] = React.useState<any>('');
    const [akamai_window , setWindow] = React.useState<any>('');

    useEffect( ()=> {
        akamai_token(JSON.stringify({"key" : key , "window" : akamai_window}))
    },[key, akamai_window])

    useEffect(() => {
        if (akamai_key && window){
            setKey(akamai_key)
            setWindow(window)
        }

    }, [akamai_key, window])

    return(
        <>
            <Grid item md={3}>
                <Tooltip title="The key needed to generate the akamai token for stream protection" placement='top-end' aria-multiline>
                    <TextField
                        placeholder="Akamai Key"
                        variant="outlined"
                        name="key"
                        value={akamai_key}
                        fullWidth
                        onChange={e => {setKey(e.target.value)}}
                    />
                </Tooltip>
            </Grid>
            <Grid item md={3}>
                <Tooltip title="Time in minutes of validity" placement='top-end' aria-multiline>
                    <TextField
                        placeholder="Window"
                        variant="outlined"
                        name='window'
                        value={window}
                        fullWidth
                        onChange={e => {setWindow(e.target.value)}}
                    />
                </Tooltip>
            </Grid>
        </>

    )
}




export default AkamaiToken;